export default __webpack_public_path__ + "media/Objective/Objective-Thin-Italic-5ac70c4530b16ff56aa29b833e43e864.woff2";